import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { productAccessorShouldDisplayReviews } from '../../model/productAccessor/productAccessorShouldDisplayReviews'
import { useProductPageContext } from '../productPageContext'

import { ProductFaqAndReviewsTabs } from './ProductFaqAndReviewsTabs'
import { ProductFaqs } from './ProductFaqs'
import { ProductReviews } from './ProductReviews'

const USER_QUESTIONS_SECTION_ID = 'user-questions-section'
const USER_REVIEWS_SECTION_ID = 'user-reviews-section'

const ProductFaqAndReviews: FC<{ className?: string }> = ({ className }) => {
  const { faqs, isMasterPage, product } = useProductPageContext()
  const { tenant } = useGlobalConfigContext()

  const shouldRenderFaqs = faqs && faqs.length > 0
  const shouldRenderReviews = productAccessorShouldDisplayReviews({
    product,
    tenant,
  })

  if (isMasterPage || (!shouldRenderFaqs && !shouldRenderReviews)) {
    return null
  }

  const shouldRenderBoth = shouldRenderFaqs && shouldRenderReviews

  if (shouldRenderBoth) {
    return (
      <ProductFaqAndReviewsTabs
        className={className}
        faqsSectionId={USER_QUESTIONS_SECTION_ID}
        reviewsSectionId={USER_REVIEWS_SECTION_ID}
      />
    )
  }

  return (
    <div className={className}>
      {shouldRenderFaqs ? (
        <>
          <div className="scroll-mt-4" id={USER_QUESTIONS_SECTION_ID} />
          <ProductFaqs />
        </>
      ) : null}
      {shouldRenderReviews ? (
        <>
          <div className="scroll-mt-4" id={USER_REVIEWS_SECTION_ID} />
          <ProductReviews />
        </>
      ) : null}
    </div>
  )
}

export { ProductFaqAndReviews }
